import React from 'react';
import { AppBar, Toolbar, styled } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Colors, TextButton } from 'library';
import { useUserContext } from 'UserContext';
import NavyLogo from 'assets/images/NavyLogo.svg';

export default function StakeholderNav() {
    const { logout } = useUserContext();

    return (
        <AppBar position="static" sx={{ backgroundColor: Colors.white, boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)' }}>
            <ThinToolbar disableGutters>
                <NavyLogo height={40} width={120} alt="tandem logo" />
                <SignOutSlot>
                    <TextButton onClick={() => logout('/login')}>
                        <SignOutContent>
                            <LogoutOutlinedIcon fontSize="small" />
                            <span>Sign out</span>
                        </SignOutContent>
                    </TextButton>
                </SignOutSlot>
            </ThinToolbar>
        </AppBar>
    );
}

const ThinToolbar = styled(Toolbar)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: 'none',
    paddingLeft: 24,
    paddingRight: 24,
});

const SignOutSlot = styled('div')({
    marginLeft: 'auto',
});

const SignOutContent = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    textTransform: 'none',
});
